function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Swatch
 *    Scripts for the swatch object.
 *
 *
 *  Version:
 *    1.0.1 - 2020/10/09
 */

import { escapeString, handlize } from '@process-creative/slate-theme-tools';
import { VariantSelector, ON_VARIANT_CHANGE } from './../variant/VariantSelector';
export { ON_VARIANT_CHANGE } from './../variant/VariantSelector';

//Selectors
export var SWATCH_CONTAINER_SELECTOR = '[data-swatches]';
export var SWATCH_OBJECT_SELECTOR = '[data-swatch-object]';
export var SWATCH_SELECTOR_SELECTOR = '[data-swatch-selector]';
export var SWATCH_VALUE_DISPLAY_SELECTOR = '[data-swatch-value]';

//Errors
export var ERROR_SWATCH_POSITION = 'Target Swatch is missing the position attribute! [data-swatch-position]';
export var ERROR_CURRENT_VARIANT = 'Failed to get currently selected variant!';
export var ERROR_NO_OPTION = 'Failed to find a variant selector option to match current swatch selection!';

//Class
var IS_HIDDEN = 'is-hidden';
export var Swatch = /*#__PURE__*/function (_VariantSelector) {
  _inherits(Swatch, _VariantSelector);
  var _super = _createSuper(Swatch);
  function Swatch(container) {
    var _this;
    _classCallCheck(this, Swatch);
    _this = _super.call(this, container);
    //Trigger an update on page load.
    _this.updateAvailableSwatches();
    return _this;
  }
  _createClass(Swatch, [{
    key: "onSwatchClicked",
    value: function onSwatchClicked(e) {
      var self = $(e.currentTarget);
      this.setVariantFromSwatch(self, self.attr('data-value'));
    }
  }, {
    key: "onSwatchSelected",
    value: function onSwatchSelected(e) {
      var self = $(e.currentTarget);
      this.setVariantFromSwatch(self, self.val());
    }
  }, {
    key: "onSwatchVariantChanged",
    value: function onSwatchVariantChanged(variant, variantId) {
      //All swatch objects lose focus
      this.container.find(SWATCH_OBJECT_SELECTOR).removeClass('is-selected');

      //Trigger an update (this will hide/show appropriate swatches)
      this.updateAvailableSwatches();

      //Now iterate over the options...
      for (var i = 1; i <= this.data.options.length; i++) {
        //Get value at this option
        var value = variant.options[i - 1];
        var ps = "[data-swatch-position=\"".concat(i, "\"]"); //Position Selector
        var vs = "[data-value=\"".concat(handlize(value), "\"]"); //Value Selector

        //Now we can add the class to the selected object
        this.container.find(SWATCH_OBJECT_SELECTOR + ps + vs).addClass('is-selected');

        //Change the value of the selectors
        this.container.find(SWATCH_SELECTOR_SELECTOR + ps).val(handlize(value));
        this.container.find(SWATCH_VALUE_DISPLAY_SELECTOR + ps).html(value.toLowerCase());
      }
    }
  }, {
    key: "setVariant",
    value: function setVariant(id) {
      _get(_getPrototypeOf(Swatch.prototype), "setVariant", this).call(this, id);

      //Fetch data and update the swatches
      var variant = this.data.variants.find(function (v) {
        return v.id == id;
      });
      return this.onSwatchVariantChanged(variant, id);
    }
  }, {
    key: "setVariantFromSwatch",
    value: function setVariantFromSwatch(el, value) {
      //Triggers a standard variant change based on a swatch

      //Get the current swatch index and position
      var _map = ['data-index', 'data-swatch-position'].map(function (e) {
          return el.attr(e);
        }),
        _map2 = _slicedToArray(_map, 2),
        index = _map2[0],
        position = _map2[1];
      if (!position) throw new Error(ERROR_SWATCH_POSITION);

      //Get the current variant data.
      var currentVariant = this.getVariantData();
      if (!currentVariant) throw new Error(ERROR_CURRENT_VARIANT);

      //Ok so I was running into a problem regarding multiple levels of variants
      //And this is caused by non standard variants
      //e.g. if a product has the variants:
      // Material Cloth, Color Red
      // Material Cloth, Color Blue
      // Material Silk, Color Red
      // Material Silk, Color Green
      //It will show the color green even if the material is currently cloth, and
      //Will fail to select the variant if there's.. yada yada etc etc basically
      //we need to only show variant subs for variants of top level-ness

      //This is the <option> from within the standard variant selector we're trying
      //to fetch and read the variant id from!
      var selector = '[data-variant-option]';
      var target;

      //Now, for each option (1..2..3)
      for (var i = 1; i <= this.data.options.length; i++) {
        var selectorValue = void 0; //We will store the value for this option index, e.g. "Red" for Option1 and "Silk" for Option2...

        //Get the current value at this option
        selectorValue = currentVariant.options[i - 1];

        //However, if this index is the position of the swatch that was triggering this update, then use ITS value (thus updating
        if (i == position) selectorValue = value;

        //Store Current jQuery selector
        var selectorTemp = "".concat(selector);

        //Append to the new selector..
        selector += "[data-option".concat(i, "=\"").concat(handlize(selectorValue), "\"]");

        //Now we need to check if the variant we're after even exists.
        target = this.container.find(selector);

        //If it DOESN'T, then the current option index doesn't exist (e.g. Option1 is Silk Okay, But Option2 is Blue, not okay)
        if (target.length) continue;

        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = "".concat(selectorTemp, "[data-option").concat(i, "]:first");
        target = this.container.find(selector);
      }

      //Now we should have a selector for a variant that actually exists, let's get it
      if (!target.length) {
        throw new Error("".concat(ERROR_NO_OPTION, "\nSelector").concat(selector));
      }

      //Find the variant ID based from the selection, and set it.
      this.setVariant(target.val());
    }
  }, {
    key: "updateAvailableSwatches",
    value: function updateAvailableSwatches() {
      var _this2 = this;
      var current = this.getVariantData();

      //Set Swatch Objects to hidden & sold out
      var objects = this.container.find(SWATCH_OBJECT_SELECTOR);
      ['is-sold-out'].forEach(function (e) {
        return objects.addClass(e);
      });

      //Hide swatch selector options
      this.container.find("".concat(SWATCH_SELECTOR_SELECTOR, " option")).attr('disabled', 'disabled');

      //Top level are always visibile, if there's sub levels
      var tls = "[data-swatch-position=\"1\"]";
      this.container.find(SWATCH_OBJECT_SELECTOR + tls).removeClass('is-hidden');
      this.container.find("".concat(SWATCH_SELECTOR_SELECTOR + tls, " option")).removeAttr('disabled');

      //Now go over reach option to determine visible swatches
      var _loop = function _loop(i) {
        //Given the selected previous level, what options for *this* level are available?
        var pi = "option".concat(i - 1);
        var prevOption = current[pi];
        var allowedOptionsForThisLevel = [];
        _this2.data.variants.forEach(function (v) {
          var n = v["option" + i];

          //If current iterated variant has the same previous option AND is not already in the list of allowed values...
          if (allowedOptionsForThisLevel.indexOf(n) === -1 && v[pi] == prevOption) {
            allowedOptionsForThisLevel.push(n); //Add to list.
          }
        });

        allowedOptionsForThisLevel.forEach(function (ao) {
          var aos = "[data-swatch-position=\"".concat(i, "\"]");
          _this2.container.find(SWATCH_OBJECT_SELECTOR + aos + "[data-value=\"".concat(handlize(ao), "\"]")).removeClass('is-hidden');
          //Comment this out if you want to disable sold out select swatches
          _this2.container.find(SWATCH_SELECTOR_SELECTOR + aos + " [value=\"".concat(handlize(ao), "\"]")).removeAttr('disabled');
        });
      };
      for (var i = 2; i <= this.data.options.length; i++) {
        _loop(i);
      }

      //Now determine what's sold out for each given level
      var _loop2 = function _loop2(_i2) {
        var avail = {}; //Stores availability of option[i]'s value.

        //Find if there are any variants for this option with stock available
        _this2.data.variants.forEach(function (v) {
          //Check previous options match, since we don't want to check stock of
          //other levels
          var canUse = true;
          for (var y = 1; y < _i2; y++) {
            var oy = "option".concat(y);
            if (v[oy] == current[oy]) continue;
            canUse = false;
            break;
          }
          if (!canUse) return;
          var n = v["option" + _i2];
          if (_typeof(avail[n]) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) avail[n] = v.available;
          avail[n] = avail[n] || v.available;
        });

        //Now remove these as sold out.
        var keys = Object.entries(avail).forEach(function (e) {
          var _e2 = _slicedToArray(e, 2),
            key = _e2[0],
            value = _e2[1];
          if (!value) return;
          _this2.container.find("".concat(SWATCH_OBJECT_SELECTOR, "[data-swatch-position=\"").concat(_i2, "\"][data-value=\"").concat(handlize(key), "\"]")).removeClass('is-sold-out');
          _this2.container.find("".concat(SWATCH_SELECTOR_SELECTOR, "[data-swatch-position=\"").concat(_i2, "\"] [value=\"").concat(handlize(key), "\"]")).removeAttr('disabled');
        });
      };
      for (var _i2 = 1; _i2 <= this.data.options.length; _i2++) {
        _loop2(_i2);
      }
      this.updateVisibleSizeOptionsBasedOnColor(current);
    }
  }, {
    key: "updateVisibleSizeOptionsBasedOnColor",
    value: function updateVisibleSizeOptionsBasedOnColor(current) {
      //updateVisibleSizeOptionsBasedOnColor
      var colorOption = this.data.options.reduce(function (returnVal, option, index) {
        if (returnVal) return returnVal;
        var optionIsColor = ['color', 'colour'].some(function (c) {
          return c == option.toLowerCase();
        });
        return optionIsColor && "option".concat(index + 1);
      }, null);
      var currentColor = current[colorOption];
      var allVariantsForThatColor = this.data.variants.filter(function (v) {
        return v[colorOption] == currentColor;
      }).map(function (v) {
        return v.id;
      });
      var swatches = Array.from(this.container.find("[data-swatch-option-name]"));
      var sizeSwatches = swatches.filter(function (s) {
        return s.dataset.swatchOptionName.toLowerCase() == 'size';
      });
      var sizeOptionsElems = Array.from($(sizeSwatches).find('option'));
      sizeOptionsElems.forEach(function (option) {
        var colorHasSize = allVariantsForThatColor.some(function (variantId) {
          return $(option).attr('data-option-variant-id') == variantId;
        });
        colorHasSize ? $(option).removeClass(IS_HIDDEN) : $(option).addClass(IS_HIDDEN);
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      _get(_getPrototypeOf(Swatch.prototype), "attachEvents", this).call(this);
      this.boundSwatchClick = function (e) {
        return _this3.onSwatchClicked(e);
      };
      this.container.on('click', SWATCH_OBJECT_SELECTOR, this.boundSwatchClick);
      this.boundSwatchSelect = function (e) {
        return _this3.onSwatchSelected(e);
      };
      this.container.on('change', SWATCH_SELECTOR_SELECTOR, this.boundSwatchSelect);
      if (this.shouldUseEvents()) {
        this.boundSwatchVariantChange = function (e, variant, variantId) {
          return _this3.onSwatchVariantChanged(variant, variantId);
        };
        $(document).on(ON_VARIANT_CHANGE, this.boundSwatchVariantChange);
      }
    }
  }, {
    key: "detachEvents",
    value: function detachEvents() {
      _get(_getPrototypeOf(Swatch.prototype), "detachEvents", this).call(this);
      if (this.boundSwatchClick) this.container.off('click', SWATCH_OBJECT_SELECTOR, this.boundSwatchClick);
      if (this.boundSwatchSelect) this.container.off('change', SWATCH_SELECTOR_SELECTOR, this.boundSwatchSelect);
      if (this.boundSwatchVariantChange) $(document).off(ON_VARIANT_CHANGE, this.boundSwatchVariantChange);
    }
  }]);
  return Swatch;
}(VariantSelector);